"use client";

import styles from "./_navigation.module.scss";
import { createStyleResolver } from "@/service/class-naming";
import { useEffect, useState } from "react";
import { getAssetImage } from "@/service/image/asset";
import { Button } from "@/components/ui/button";
import { createPath } from "@/service/routing/routing";

const sr = createStyleResolver(styles);

const Navigation = () => {
  const [isSticked, setIsSticked] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      const { scrollY } = window;
      setIsSticked(scrollY > 160);
    });

    return () => {
      window.removeEventListener("scroll", () => {});
    };
  });

  return (
    <div className={sr("navigation", { sticked: isSticked })}>
      <div className={sr("logo")}>
        <img src={getAssetImage("/logo-white.svg")} alt="remedium logo" />
      </div>
      <div className={sr("buttons")}>
        <Button size={"sm"} variant={"outline"}>
          <a href={createPath("security.login")}>Zaloguj się</a>
        </Button>
        <Button size={"sm"} asChild={true} variant={"blue"}>
          <a href={createPath("security.registration")}>Dołącz</a>
        </Button>
      </div>
    </div>
  );
};

export default Navigation;
